<template>
    <div>
        <!--<label class="pb-2">{{field.etiqueta}}</label>-->
        <gmap-map
            :center="center"
            :zoom="zoom"
            style="width:100%;  height: 400px;"
        >
            <gmap-marker
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="center=m.position"
                draggable
                @dragend="dragEnd"
                :icon="markerOptions"
            ></gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import axios from 'axios'
import {mapGetters, mapState} from "vuex";

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
        libraries: ''
    }
})

export default {
    name: "Map",
    props: ['field', 'readonly', 'label', 'formValues'],
    data(){
        return {
            center: { lat: 45.508, lng: -73.587 },
            markers: [],
            zoom: 16,
            currentPlace: null,
            markerOptions: {
                scaledSize: {width: 25, height: 25, f: 'px', b: 'px',}
            },
            calle: "",
            numero: "",
            colonia: "",
            cp: "",
            municipio: "",
            estado: "",
            direccion: [],
            address: ""
        }
    },

    watch: {
        formValues: {
            handler: function (value) {
                this.direccion = ({
                    calle: this.buscaValue(this.field.extra.point_calle.replace("@@", ""), value[this.field.extra.point_calle.replace("@@", "")]),
                    colonia: this.buscaValue(this.field.extra.point_colonia.replace("@@", ""), value[this.field.extra.point_colonia.replace("@@", "")]),
                    cp: this.buscaValue(this.field.extra.point_cp.replace("@@", ""), value[this.field.extra.point_cp.replace("@@", "")]),
                    estado: this.buscaValue(this.field.extra.point_estado.replace("@@", ""), value[this.field.extra.point_estado.replace("@@", "")]),
                    municipio: this.buscaValue(this.field.extra.point_municipio.replace("@@", ""), value[this.field.extra.point_municipio.replace("@@", "")]),
                    numero: this.buscaValue(this.field.extra.point_numero.replace("@@", ""), value[this.field.extra.point_numero.replace("@@", "")])
                });
                this.municipio = this.direccion.municipio
                this.calle = this.direccion.calle
                this.colonia = this.direccion.colonia
                this.cp = this.direccion.cp
                this.estado = this.direccion.estado
                this.numero = this.direccion.numero
                this.address = ""
                if(this.direccion.calle){
                    this.address = this.address + this.direccion.calle
                }
                if(this.direccion.numero){
                    this.address = this.address + " " + this.direccion.numero
                }
                if(this.direccion.colonia){
                    this.address = this.address + " " + this.direccion.colonia
                }
                if(this.direccion.cp){
                    this.address = this.address + " " + this.direccion.cp
                }
                if(this.direccion.municipio){
                    this.address = this.address + " " + this.direccion.municipio
                }
                if(this.direccion.estado){
                    this.address = this.address + " " + this.direccion.estado
                }
            },
            deep: true
        },
        municipio: {
            handler: function(){
                this.getCoords(this.address)
            },
            deep: true
        },
        calle: {
            handler: function(){
                this.getCoords(this.address)
            },
            deep: true
        },
        colonia: {
            handler: function(){
                this.getCoords(this.address)
            },
            deep: true
        },
        cp: {
            handler: function(){
                this.getCoords(this.address)
            },
            deep: true
        },
        estado: {
            handler: function(){
                this.getCoords(this.address)
            },
            deep: true
        },
        numero: {
            handler: function(){
                this.getCoords(this.address)
            },
            deep: true
        }
    },

    mounted() {
        console.log('mounted ...')
        //this.geolocate();
        if(this.field.extra.icon_marker){
            this.markerOptions = {
                url: String(this.field.extra.icon_marker),
                scaledSize: {width: 25, height: 25, f: 'px', b: 'px',}
            }
        }
        if (!this.formValues[this.field.nombre]){
            this.initDefaultValues()
        }else{
            this.initWithSavedValues()
        }
    },

    computed: {
        ...mapState({proceduresStore: state => state.procedures}),
        ...mapGetters('procedures', ['procedureDataForm', 'form', 'procedureData', 'procedureMeta', 'returnLastCondition'])
    },

    methods: {
        getCoords(value){
                axios
                    .get('https://insumos.nl.gob.mx/api/get-point?address=' + this.address.trim().replace(/\[object Object\]/g, ""))
                    .then(response => {
                        this.markers = [{ position: {
                                lat: response.data.lat,
                                lng: response.data.lng,
                            }
                        }];
                        this.center = {
                            lat: response.data.lat,
                            lng: response.data.lng,
                        };
                        this.zoom = 17
                    })
                this.updateValue()
                console.log(value.replace(/\[object Object\]/g, ""))
        },

        setPlace(place) {
            this.currentPlace = place;
        },
        initDefaultValues() {
            this.zoom = parseInt(this.field.extra.init_zoom)

            const marker = {
                lat: parseFloat(this.field.extra.init_lat),
                lng: parseFloat(this.field.extra.init_lng),
            };

            if (this.field.extra.marker == '1'){
                this.markers.push({ position: marker });
            }

            this.center = marker;
            this.currentPlace = null;

            this.updateValue()
        },

        buscaValue(campo, valor){
            var dato = valor
            if(dato && dato.label){
                dato = valor.label
            }
            for(var x in this.form){
                if(this.form[x].nombre == campo){
                    for(var y in this.form[x].datos){
                        if(this.form[x].datos[y].value == valor){
                            dato = this.form[x].datos[y].label
                        }
                    }
                }
            }
            
            return dato
        },

        initWithSavedValues(){
            let values = JSON.parse(this.formValues[this.field.nombre])

            if (values.length > 0){
                this.zoom = values[0].point.zoom
                this.center = values[0].point.center

                if (this.field.extra.marker == '1'){
                    this.markers.push({ position: values[0].point.marker });
                }
            }else {
                this.initDefaultValues()
            }
        }
        /*,
        geolocate: function() {
            navigator.geolocation.getCurrentPosition(position => {
                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
            });
        }*/
        ,

        dragEnd(position){
            this.center = position.latLng
            this.updateValue()

            console.log(position)
        },

        updateValue(){
            var value = [
                {
                    point: {
                        center: this.center,
                        zoom: this.zoom,
                        marker: this.center
                    },
                    poligono: 
                        this.center
                    ,
                    zoom: this.field.extra.init_zoomPol,
                    points: {}


                }
            ]

            if(this.field.extra.poligono){
                value = [
                    {
                        point: {
                            center: this.center,
                            zoom: this.zoom,
                            marker: this.center
                        },
                        poligono: this.center,
                        zoom: this.field.extra.init_zoomPol,
                        points: {
                            poligono: JSON.parse(this.field.extra.init_coord_polygon)
                        }


                    }
                ]
            }

            this.formValues[this.field.nombre] = JSON.stringify(value)
        }
    }
}
</script>
